import React from 'react'
import DownloadRow from "./DownloadRow"

const Info = () => {
    return (
        <>
            {/* main content */}
            <div id = {'mri-info'} className="lg:flex items-stretch bg-white">
                {/* mri info */}
                <div className="lg:w-1/4 flex items-start flex-shrink-0">
                    {/* left bar */}
                    <div className="flex-shrink-0 w-10 h-full bg-white xl:hidden"></div>
                    
                    <div className="py-12 pr-6 xl:p-12 flex-grow">
                        <h2 className="font-extrabold uppercase text-2xl xl:text-3xl text-gray-text border-b-2 border-gray-text mb-6 inline-block">MRI Information</h2>
                        <p className="text-gray-text font-light text-sm xl:text-base 2xl:text-lg leading-relaxed">
                            Magnetic Resonance Imaging (MRI)
                            Information for CORCYM heart valve
                            prostheses and annuloplasty devices
                        </p>
                    </div>
                
                </div>

                {/* main content */}

                <div className="lg:w-3/4">
                    <div className="h-full flex items-stretch flex-shrink-0">
                        <div className="flex-grow bg-white px-4 py-8 lg:pt-20 lg:pb-16">
                            
                            {/* download rows */}
                                <DownloadRow
                                title="MAGNETIC RESONANCE IMAGING (MRI) INFORMATION"
                                region="For Use in the USA Market Only"
                                link="https://corcym.s3.eu-central-1.amazonaws.com/devices/MRI-Information/US/CC-MK-00001_Rev+E+-+MRI+for+US.pdf"
                                />
                                
                                <DownloadRow
                                    title="MAGNETIC RESONANCE IMAGING (MRI) INFORMATION"
                                    region="FOR USE IN THE WORLDWIDE MARKETS WITH THE EXCEPTION OF THE USA"
                                    link="https://corcym.s3.eu-central-1.amazonaws.com/devices/MRI-Information/OUS/CC-MK-00000_Rev_E+-+MRI+for+OUS.pdf"
                                />

                                <DownloadRow
                                    title="INFORMATIONS SUR L’IMAGERIE PAR RÉSONANCE MAGNÉTIQUE (IRM)"
                                    region="À UTILISER SUR LES MARCHÉS INTERNATIONAUX, SAUF AUX ÉTATS-UNIS"
                                    link="https://corcym.s3.eu-central-1.amazonaws.com/media/MRI/CC-MK-00000-FR+D+mri.pdf"
                                />
                                
                                <DownloadRow
                                    title="INFORMATIONEN ZUR MAGNETRESONANZTOMOGRAPHIE (MRT)"
                                    region="Für den Einsatz in allen Märkten weltweit mit Ausnahme der Vereinigten Staaten"
                                    link="https://corcym.s3.eu-central-1.amazonaws.com/media/MRI/CC-MK-00000-DE+D+-+MRI+for+OUS_de.pdf"
                                />
                                <DownloadRow
                                    title="INFORMAZIONI SULLA RISONANZA MAGNETICA NUCLEARE (RMN)"
                                    region="Da utilizzare in tutti i mercati mondiali, ad eccezione degli Stati Uniti"
                                    link="https://corcym.s3.eu-central-1.amazonaws.com/media/MRI/CC-MK-00000-IT_D+-+MRI+for+OUS.pdf"
                                />
                            {/* download rows */}
                        </div>
                        <div className="hidden lg:block flex-shrink-0 w-10 bg-white"></div>
                    </div>
                </div>

                
            </div>
            {/* main content */}
        </>
    )
}

export default Info
